export const pushQueryParam = (key, value) => {
  const url = new URL(window.location)
  const searchParams = url.searchParams
  searchParams.set(key, value)

  // Update the URL in the browser without reloading the page
  window.history.pushState({}, '', url)
}

export const getQueryParam = (key) => {
  const url = new URL(window.location)
  const searchParams = url.searchParams
  return searchParams.get(key)
}

export const deleteQueryParam = (key) => {
  const url = new URL(window.location)
  const searchParams = url.searchParams
  searchParams.delete(key)

  const select = document.querySelectorAll("select[name^='" + key + "']")
  if (select.length > 0) {
    const defaultOption = select[0].options[0]
    select[0].value = defaultOption.value
  }

  // Update the URL in the browser without reloading the page
  window.history.pushState({}, '', url)
}
